import { useEffect } from "react";
import { useLocation, Navigate, Outlet, useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import axios from 'axios';

const AUTH_URL = `${process.env.REACT_APP_API_URL}/auth/login`;

const PUBLIC_PATHS = [
  '/login',
  '/recuperar-contrasena',
  '/recuperar-contraseña',
  '/restablecer-contrasena',
  '/restablecer-contraseña',
  '/cambiarPasswordVencida'
];

const RequireAuth = ({ allowedRoles }) => {
  const { auth, setAuth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const token = auth?.token;

  useEffect(() => {
    // 🔒 NO validar en rutas públicas
    if (PUBLIC_PATHS.includes(location.pathname)) {
      return;
    }

    if (!token) {
      return;
    }

    const verify = async () => {
      try {
        await axios.get(AUTH_URL, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        });
      } catch (err) {
        const msg = err?.response?.data?.message || '';
        const passwordVencida =
          err?.response?.status === 401 && msg.toLowerCase().includes('vencida');
        const email = auth?.user;

        setAuth({});
        window.localStorage.removeItem('auth');

        // Si lo sacamos por contraseña vencida, va directo al formulario
        // de cambio (contraseña actual + nueva) en lugar del login.
        if (passwordVencida) {
          navigate('/cambiarPasswordVencida', { replace: true, state: { email } });
        } else {
          navigate('/login', { replace: true });
        }
      }
    };

    verify();
  }, [token, location.pathname, navigate, setAuth]);

  // 🔐 Si no está autenticado y no es pública → login
  if (!token && !PUBLIC_PATHS.includes(location.pathname)) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default RequireAuth;